import { render, staticRenderFns } from "./snipplet.vue?vue&type=template&id=7f15dd4c&scoped=true"
import script from "./snipplet.vue?vue&type=script&lang=js"
export * from "./snipplet.vue?vue&type=script&lang=js"
import style0 from "./snipplet.vue?vue&type=style&index=0&id=7f15dd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15dd4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBadge,VBtn,VCard,VCardActions,VCardSubtitle,VCardText,VListItem,VListItemContent,VListItemSubtitle,VProgressLinear,VSwitch})
